/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 19:15:05
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-06 19:15:13
 * @FilePath: \senlan-ai-ui\src\stores\global.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/atoms/globalAtom.ts
import { atom } from 'jotai'

// 1️⃣ 定义初始状态
const initialGlobalState = {
  isCollapse: false,
  isOpenDrawer: false,
  isDarkMode: false,
  themeColor: '#ffffff',
  language: 'zhCN',
  borderRaduis: 4,
}

// 2️⃣ 定义主 atom（相当于 Redux 的 state）
export const globalAtom = atom(initialGlobalState)

// 3️⃣ 定义动态修改函数（相当于 setGlobalState reducer）
export const setGlobalStateAtom = atom(
  null,
  (get, set, payload: { key; value }) => {
    const prev = get(globalAtom)
    set(globalAtom, { ...prev, [payload.key]: payload.value })
  }
)
